import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { GiHamburgerMenu } from 'react-icons/gi'; 
import { MdClose } from "react-icons/md";
import { GoHome, GoCalendar } from "react-icons/go";
import { GrUserAdmin, GrUserWorker } from "react-icons/gr";
import { TbLogout2 } from "react-icons/tb";
import { RxAvatar } from "react-icons/rx";

import {
  HeaderContainer,
  HeaderLogoImage,
  TextAndImageContainer,
  Greeting,
  MenuButton,
  GreetingContainer,
  Nav,
  MenuList,
  HeaderOverlay,
  Imgs
} from '../styles';

const Header = ({userRole, userName}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false); 
  };

  return (
    <div>
      <HeaderOverlay $isOpen={isMenuOpen} onClick={toggleMenu} />
      <HeaderContainer>
        <MenuButton onClick={toggleMenu}>
          {isMenuOpen ? <MdClose /> : <GiHamburgerMenu />}
        </MenuButton>
        <TextAndImageContainer>
          <HeaderLogoImage src={Imgs.logo} alt="Logo" />
          <GreetingContainer>
            <Greeting>Olá, {userName}</Greeting>
          </GreetingContainer>
        </TextAndImageContainer>
      </HeaderContainer>
      <Nav $isOpen={isMenuOpen}>
        <MenuList>
          <li>
            <Link to="/home" onClick={handleLinkClick} style={{ display: "flex", alignItems: "center", gap: "10px", color: "rgb(40, 73, 100)", textDecoration: "none" }}>
              <GoHome size={30} />
              <span style={{ fontFamily: "Bellota", color: "#284964" }}>Início</span>
            </Link>
          </li>
          <li>
            <Link to="/home/profile" onClick={handleLinkClick} style={{ display: "flex", alignItems: "center", gap: "10px", color: "rgb(40, 73, 100)", textDecoration: "none" }}>
              <RxAvatar size={30} />
              <span style={{ fontFamily: "Bellota", color: "#284964" }}>Perfil</span>
            </Link>
          </li>
          <li>
            <Link to="/home/schedule" onClick={handleLinkClick} style={{ display: "flex", alignItems: "center", gap: "10px", color: "rgb(40, 73, 100)", textDecoration: "none" }}>
              <GoCalendar size={30} />
              <span style={{ fontFamily: "Bellota", color: "#284964" }}>Agendamento</span>
            </Link>
          </li>
          {userRole === 'admin' && (
            <li>
              <Link to="/home/admin" onClick={handleLinkClick} style={{ display: "flex", alignItems: "center", gap: "10px", color: "rgb(40, 73, 100)", textDecoration: "none" }}>
                <GrUserAdmin size={30} />
                <span style={{ fontFamily: "Bellota", color: "#284964" }}>Administrador</span>
              </Link>
            </li>
          )}
          {userRole === 'worker' && (
            <li>
              <Link to="/home/worker" onClick={handleLinkClick} style={{ display: "flex", alignItems: "center", gap: "10px", color: "rgb(40, 73, 100)", textDecoration: "none" }}>
                <GrUserWorker size={30} />
                <span style={{ fontFamily: "Bellota", color: "#284964" }}>Trabalhador</span>
              </Link>
            </li>
          )}
          <li>
            <Link to="/" onClick={handleLinkClick} style={{ display: "flex", alignItems: "center", gap: "10px", color: "rgb(40, 73, 100)", textDecoration: "none" }}>
              <TbLogout2 size={30} />
              <span style={{ fontFamily: "Bellota", color: "#284964" }}>Sair</span>
            </Link>
          </li>
        </MenuList>
      </Nav>
    </div>
  );
};

export default Header;
